import { createSlice } from '@reduxjs/toolkit';
import { ApiNoteType } from '../api-internal';

export interface NoteOption {
  key: ApiNoteType;
  value: string;
  label: string;
}

export const customerNoteValues: NoteOption[] = [
  {
    key: ApiNoteType.GENERAL,
    value: ApiNoteType.GENERAL,
    label: 'Customer notes',
  },
  {
    key: ApiNoteType.ALERT,
    value: ApiNoteType.ALERT,
    label: 'Alert notes',
  },
  {
    key: ApiNoteType.ALL,
    value: ApiNoteType.ALL,
    label: 'All notes',
  },
];

export const counterpartyNoteValues: NoteOption[] = [
  {
    key: ApiNoteType.GENERAL,
    value: ApiNoteType.GENERAL,
    label: 'Counterparty notes',
  },
  {
    key: ApiNoteType.ALERT,
    value: ApiNoteType.ALERT,
    label: 'Alert notes',
  },
  {
    key: ApiNoteType.ALL,
    value: ApiNoteType.ALL,
    label: 'All notes',
  },
];

export interface AmlFiltersState {
  notes: NoteOption;
}

export const initialState: AmlFiltersState = {
  notes: customerNoteValues[0],
};

const amlFiltersSlice = createSlice({
  name: 'amlFilters',
  initialState,
  reducers: {
    updateFilters: (state, action) => {
      state.notes = action.payload;
    },
  },
});

const { actions, reducer } = amlFiltersSlice;

export const { updateFilters } = actions;
export default reducer;
